// extracted by mini-css-extract-plugin
export default {"title":"ConfirmSetOwnerDialog_title__FRj1h","icon":"ConfirmSetOwnerDialog_icon__iSoiF"};